import React, { useState } from "react";
import { Dialog, DialogContent, Typography } from "@material-ui/core";
import { DialogCancelButton, DialogDeleteButton } from "./styles";

interface Props {
  open: boolean;
  save: (s: string) => void;
  close: () => void;
}

export default function UserValueDialog(props: Props) {
  const [text] = useState<string>("");

  return (
    <Dialog open={props.open}>
      <DialogContent>
        <div>
          <Typography>Confirm Delete?</Typography>
        </div>
        <DialogCancelButton
          onClick={() => {
            props.close();
          }}
        >
          Cancel
        </DialogCancelButton>

        <DialogDeleteButton
          onClick={() => {
            props.save(text);
            props.close();
          }}
        >
          Delete
        </DialogDeleteButton>
      </DialogContent>
    </Dialog>
  );
}
